/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': '名称未設定のページ',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': '新しいページを作成し、リンクとして挿入します',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Confluence ページを作成',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Confluence で開く',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'ページが作成されました',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'ページを作成しました',
  'editorExtensionLinkCreate.confluencePage.title': '新しいページを作成',
  'editorExtensionLinkCreate.genericError.description': 'ページを再読み込みして、もう一度お試しください。',
  'editorExtensionLinkCreate.genericError.title': '問題が発生しました',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': '課題をインラインで作成し、リンクとして挿入します',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    '作業項目をインラインで作成し、リンクとして挿入します',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Jira 課題を作成',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Jira 作業項目を作成',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Jira で開く',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': '課題が作成されました',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4':
    '作業項目が作成されました',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': '課題が作成されました',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': '作業項目が作成されました',
  'editorExtensionLinkCreate.jiraIssue.title': '新しい課題を作成する',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': '新しい作業項目を作成する',
  'editorExtensionLinkCreate.keyword.create': '作成する',
  'editorExtensionLinkCreate.keyword.issue': '課題',
  'editorExtensionLinkCreate.keyword.new': '新規',
  'editorExtensionLinkCreate.keyword.page': 'ページ',
  'editorExtensionLinkCreate.keyword.publish': '公開する',
  'editorExtensionLinkCreate.keyword.raise': '登録する',
  'editorExtensionLinkCreate.keyword.space': 'スペース',
  'editorExtensionLinkCreate.keyword.ticket': 'チケット',
};
